import {deleteMethod, getMethod, postMethod, putMethod} from '~/api'

async function get(hotelId, request) {
    return await getMethod(`/api/hotelDescription/${hotelId}/images`, request)
}

async function post(hotelId, request) {
    return await postMethod(`/api/hotelDescription/${hotelId}/images`, request)
}

async function put(hotelId, imageId, request) {
    return await putMethod(`/api/hotelDescription/${hotelId}/images/${imageId}`, request)
}

async function remove(hotelId, imageId) {
    return await deleteMethod(`/api/hotelDescription/${hotelId}/images/${imageId}`)
}

export {get, post, put, remove}
